import { PostCard } from "@/components/Blog/PostCard";
import { GhostPostsOrPages, GhostSettings } from "@/lib/ghost";

interface PostItemsProps {
  settings: GhostSettings;
  posts: GhostPostsOrPages;
  isHome?: boolean;
}

export const PostItems = ({ settings, posts, isHome }: PostItemsProps) => (
  <>
    {posts.map((post, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <PostCard key={i} {...{ settings, post, isHome, num: i }} />
    ))}
  </>
);
